import Cookies from 'js-cookie'
import { fmUserLogin, fmUserChangeUserPwd, loginInfo } from '@/view/api/ajax'
import { Message } from 'element-ui'
import SideMenuUtils from '@/utils/sideMenuUtils'
import MenuUtils from '@/utils/menuUtils'

/* ----------------------------------------*/
let sideMenus = []
let routers = []
let fmMenus = []
//
function loginData(data) {
  window.sessionStorage.setItem('menus', JSON.stringify(data))
  MenuUtils(routers, data)
  window.sessionStorage.setItem('sideMenus', JSON.stringify(sideMenus))
}
//
function filterAsyncRouter(routes) {
  let firstPage = {
    menuId: 1,
    parentId: -1,
    menuNameNick: 'page/index/index',
    menuName: '我的任务',
    menuNameEn: 'My task',
    hasChild: 'N',
    menuDepth: 2,
    childMenus: []
  };
  const sysMenus = []
  // sysMenus.push(firstPage);
  if (routes.menus && routes.menus.childMenus !== null) {
    routes.menus.childMenus.forEach(v => {
      sysMenus.push(v)
    })
  }
  const menu = {
    path: '/',
    menuNameNick: 'layout/Home',
    menuName: 'Goodpack OTMS',
    menuNameEn: 'Goodpack OTMS',
    hasChild: 'Y',
    isRoot: true
  }
  menu.childMenus = []
  for (let i = 0; i < sysMenus.length; i++) {
    if (sysMenus[i].menuDepth === 2) {
      menu.childMenus.push(sysMenus[i])
    }
  }
  SideMenuUtils(sideMenus, menu.childMenus)
  fmMenus.push(menu)
  loginData(fmMenus)
}
/* ----------------------------------------*/

/**
 * 查找指定级别的第一个菜单，如查找第一个二级菜单，则参数：menus， level=2
 * @param menus
 * @param level
 */
function findFistMenu(menus) {
  if (menus == null) {
    return null;
  }
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].hasChild == 'N') {
      return menus[i];
    } else {
      return findFistMenu(menus[i].childMenus);
    }
  }
}

function dealPath(menuNameNick) {
  while (menuNameNick.indexOf('/') > -1) {
    menuNameNick = menuNameNick.replace('/', '_')
  }
  // menuNameNick = bus.replaceAll('/', '_');
  menuNameNick = '/' + menuNameNick
  return menuNameNick
}

const login = {
  namespaced: true,
  state: {
    addRouters: [],
    clients: [],
    checkedData: null
  },
  mutations: {
    FM_USER_LOGIN_REQUEST(state, data) {
      state.addRouters = routers
      if (data.menus.childMenus != null && data.menus.childMenus.length > 0) {
        let firstMenu = findFistMenu(data.menus.childMenus);
        console.log("firstMenu-----", firstMenu)
        if (firstMenu != null) {
          localStorage.setItem('firstMenuPath', dealPath(firstMenu.menuNameNick));
          localStorage.setItem('firstMenuName', firstMenu.menuName);
        }
      }
      state.clients = data.clients
      sessionStorage.setItem('clients', JSON.stringify(data.clients))
      sessionStorage.setItem('user', JSON.stringify(data.user))
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    FM_USER_CHANGE_USER_PWD_REQUEST: (state, obj) => {
      state.checkedData = obj
    }
  },
  actions: {
    // 登录请求
    async fmUserLoginRequest({ dispatch, commit }, data) {
      let res = await fmUserLogin(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { refreshToken, token } = obj;
        localStorage.setItem("token", token);
        localStorage.setItem("refresh", refreshToken);
        localStorage.setItem('changeUser', 'N');
        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST', obj)
        //dispatch('kdOrganization/findAll',{},{root:true});
        //dispatch('kdSortingPlan/findAll',{},{root:true});

        // loginInfo({...obj.user, ...obj.clients}).then(info => {
        //   console.log(info)
        // })
      }
    },
    //切换账号
    async loginInfo({ dispatch, commit }, data) {
      let res = await loginInfo(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { user } = obj;

        obj.refreshToken = localStorage.getItem("refresh");
        obj.token = localStorage.getItem("token");
        obj.clients = sessionStorage.getItem('clients');

        sideMenus = []
        routers = []
        fmMenus = []

        localStorage.clear();
        sessionStorage.clear();

        localStorage.setItem("ms_username", user.userNo);
        localStorage.setItem("token", obj.token);
        localStorage.setItem("refresh", obj.refreshToken);

        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST', obj)
      }
    },
    //
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    async fmUserChangeUserPwdRequest({ commit }, obj) {
      const resp = await fmUserChangeUserPwd(obj)
      commit('FM_USER_CHANGE_USER_PWD_REQUEST', resp)
    }
  }
}
export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js